// src/http/context/index.ts
import { createContext } from "react";
var HttpClientContext = createContext(
  void 0
);

export {
  HttpClientContext
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vc3JjL2h0dHAvY29udGV4dC9pbmRleC50cyJdLAogICJzb3VyY2VzQ29udGVudCI6IFsiaW1wb3J0IHsgY3JlYXRlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB0eXBlIHsgSHR0cENsaWVudEluc3RhbmNlIH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5leHBvcnQgY29uc3QgSHR0cENsaWVudENvbnRleHQgPSBjcmVhdGVDb250ZXh0PEh0dHBDbGllbnRJbnN0YW5jZSB8IHVuZGVmaW5lZD4oXG4gIHVuZGVmaW5lZCxcbik7XG4iXSwKICAibWFwcGluZ3MiOiAiO0FBQUEsU0FBUyxxQkFBcUI7QUFHdkIsSUFBTSxvQkFBb0I7QUFBQSxFQUMvQjtBQUNGOyIsCiAgIm5hbWVzIjogW10KfQo=